import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Gift, Copy, Check, Users, Zap } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

const ReferralWidget = () => {
  const { user, profile } = useAuth();
  const [copied, setCopied] = useState(false);

  const referralCode = user?.id?.slice(0, 8).toUpperCase() || "XXXXXXXX";
  const referralLink = `${window.location.origin}/auth?ref=${referralCode}`;

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(referralLink);
    setCopied(true);
    toast.success("Referral link copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Card className="border-brand-200 bg-gradient-to-br from-background to-brand-50/50">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Gift className="h-5 w-5 text-brand-500" />
          Refer & Earn Credits
        </CardTitle>
        <CardDescription>
          Give 5 credits, get 10 credits for each friend who signs up
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center p-4 bg-muted rounded-lg">
            <Users className="h-6 w-6 mx-auto mb-2 text-brand-500" />
            <p className="text-2xl font-bold text-foreground">0</p>
            <p className="text-xs text-muted-foreground">Friends Invited</p>
          </div>
          <div className="text-center p-4 bg-muted rounded-lg">
            <Zap className="h-6 w-6 mx-auto mb-2 text-brand-500" />
            <p className="text-2xl font-bold text-foreground">0</p>
            <p className="text-xs text-muted-foreground">Credits Earned</p>
          </div>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Your Referral Link</label>
          <div className="flex gap-2">
            <Input
              value={referralLink}
              readOnly
              className="font-mono text-sm"
            />
            <Button onClick={copyToClipboard} variant="outline" className="shrink-0">
              {copied ? (
                <Check className="h-4 w-4" />
              ) : (
                <Copy className="h-4 w-4" />
              )}
            </Button>
          </div>
        </div>

        <div className="flex items-center gap-2 p-3 bg-brand-100 rounded-lg">
          <Badge className="bg-brand-500 text-white">Your Code</Badge>
          <span className="font-mono font-bold text-brand-700">{referralCode}</span>
        </div>

        <div className="text-xs text-muted-foreground">
          <p>• Your friend gets 5 bonus credits on signup</p>
          <p>• You get 10 credits when they complete their first transformation</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReferralWidget;
